import React from "react";
import { Grid, Typography } from "@mui/material";
import InputFileUpload from "./InputFileUpload";
import CommonButton from "../Button";
import Template from "./Template";

const BulkUploadSection = ({
  title = "Bulk Upload",
  onFileChange,
  onUpload,
  onDownloadTemplate,
  onDownloadReference,
  fileName,
  accept = ".xlsx, .xls",
  children,
}) => {
  return (
    <Grid
      container
      sx={{
        backgroundColor: "#F5F8FF",
        maxWidth: "100%",
        margin: "10px",
        padding: "20px",
        borderRadius: "5px",
        fontWeight: 600,
        fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
      }}
    >
      <Grid container sx={{ marginBottom: "10px" }}>
        <Typography variant="h6">{title}</Typography>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: fileName || children ? "10px" : "0",
        }}
      >
        <Grid item xs={12} sm={6} md="auto" lg={3}>
          <InputFileUpload onChange={onFileChange} accept={accept} />
        </Grid>
        <Grid item xs={12} sm={6} md="auto" lg={3}>
          <CommonButton name={"Upload"} handleOnClick={onUpload} />
        </Grid>
        {onDownloadTemplate && (
          <Grid item xs={12} sm={6} md="auto" lg={3}>
            <Template label={"Download Template"} onClick={onDownloadTemplate} />
          </Grid>
        )}
        {onDownloadReference && (
          <Grid item xs={12} sm={6} md="auto" lg={3}>
            <Template label={"Download Reference Code"} onClick={onDownloadReference} />
          </Grid>
        )}
      </Grid>
      {fileName && (
        <Grid container sx={{ marginBottom: children ? "10px" : "0" }}>
          <Typography
            variant="caption"
            display="block"
            sx={{
              fontWeight: 500,
              color: "#33499F",
              fontStyle: "italic",
            }}
          >
            Selected File: {fileName}
          </Typography>
        </Grid>
      )}
      {children && <Grid container>{children}</Grid>}
    </Grid>
  );
};

export default BulkUploadSection;
